import {NgModule} from '@angular/core';
import {Routes, RouterModule} from '@angular/router';
import {LoginRoutingModule} from './pages/auth-pages/login/login-routing.module';
import {PAGES_AND_PATHS} from './constants/pages-and-paths';
import {UserListRoutingModule} from './pages/admin-pages/user-list/user-list-routing.module';
import {ForgotPasswordRoutingModule} from './pages/auth-pages/forgot-password/forgot-password-routing.module';
import {ResetPasswordRoutingModule} from './pages/auth-pages/reset-password/reset-password-routing.module';
import {DashboardRoutingModule} from './pages/admin-pages/dashboard/dashboard-routing.module';
import {SettingsRoutingModule} from './pages/admin-pages/settings/settings-routing.module';
import {BusinessListRoutingModule} from './pages/admin-pages/business-list/business-list-routing.module';
import {ReservationsRoutingModule} from './pages/admin-pages/reservations/reservations-routing.module';
import {NotificationsRoutingModule} from './pages/admin-pages/notifications/notifications-routing.module';
import {BannersRoutingModule} from './pages/admin-pages/banners/banners-routing.module';
import {PagesRoutingModule} from './pages/admin-pages/pages/pages-routing.module';
import {FaqRoutingModule} from './pages/admin-pages/faq/faq-routing.module';
import {AdminListRoutingModule} from './pages/admin-pages/admin-list/admin-list-routing.module';
import {BusinessProfileRoutingModule} from './pages/admin-pages/business-profile/business-profile-routing.module';
import {PriceListCategoryRoutingModule} from './pages/admin-pages/business-profile/price-list-category/price-list-category-routing.module';
import {PriceListCategoryItemCreateOrEditRoutingModule} from './pages/admin-pages/business-profile/price-list-category-item-create-or-edit/price-list-category-item-create-or-edit-routing.module';
import {PresentsRoutingModule} from './pages/admin-pages/presents/presents-routing.module';
import {CreateOrEditPresentRoutingModule} from './pages/admin-pages/presents/create-or-edit-present/create-or-edit-present-routing.module';
import {SinglePresentRoutingModule} from './pages/admin-pages/presents/single-present/single-present-routing.module';
import {InvitationsRoutingModule} from './pages/admin-pages/invitations/invitations-routing.module';
import {SingleReservationRoutingModule} from './pages/admin-pages/reservations/single-reservation/single-reservation-routing.module';
import {HomeRoutingModule} from './pages/landing-pages/home/home-routing.module';
import {AboutUsRoutingModule} from './pages/landing-pages/about-us/about-us-routing.module';
import {ContactRoutingModule} from './pages/landing-pages/contact/contact-routing.module';
import {BlogsRoutingModule} from './pages/landing-pages/blogs/blogs-routing.module';
import {SingleBlogRoutingModule} from './pages/landing-pages/blogs/single-blog/single-blog-routing.module';
import {ForBusinessesRoutingModule} from './pages/landing-pages/for-businesses/for-businesses-routing.module';
import {PrivacyPolicyRoutingModule} from './pages/landing-pages/privacy-policy/privacy-policy-routing.module';
import {TermsOfUseRoutingModule} from './pages/landing-pages/terms-of-use/terms-of-use-routing.module';
import {AdminBlogsRoutingModule} from './pages/admin-pages/landing/admin-blogs/admin-blogs-routing.module';
import {EditBlogRoutingModule} from './pages/admin-pages/landing/admin-blogs/edit-blog/edit-blog-routing.module';
import {UserExperiencesRoutingModule} from './pages/admin-pages/landing/user-experiences/user-experiences-routing.module';

const routes: Routes = [
    {
        path: '',
        pathMatch: 'full',
        redirectTo: PAGES_AND_PATHS.landingHome.pagePath
    },
];

@NgModule({
    imports: [
      RouterModule.forRoot(routes, {
        scrollPositionRestoration: 'top'
      }),
      LoginRoutingModule,
      ForgotPasswordRoutingModule,
      ResetPasswordRoutingModule,
      DashboardRoutingModule,
      SettingsRoutingModule,
      AdminListRoutingModule,
      UserListRoutingModule,
      BusinessListRoutingModule,
      SingleReservationRoutingModule,
      ReservationsRoutingModule,
      NotificationsRoutingModule,
      BannersRoutingModule,
      PagesRoutingModule,
      FaqRoutingModule,
      BusinessProfileRoutingModule,
      PriceListCategoryRoutingModule,
      PriceListCategoryItemCreateOrEditRoutingModule,
      PresentsRoutingModule,
      CreateOrEditPresentRoutingModule,
      SinglePresentRoutingModule,
      InvitationsRoutingModule,
      PrivacyPolicyRoutingModule,
      TermsOfUseRoutingModule,
      AdminBlogsRoutingModule,
      EditBlogRoutingModule,
      UserExperiencesRoutingModule,
      // Landing pages
      HomeRoutingModule,
      AboutUsRoutingModule,
      BlogsRoutingModule,
      SingleBlogRoutingModule,
      ForBusinessesRoutingModule,
      ContactRoutingModule,
    ],
    exports: [RouterModule]
})
export class AppRoutingModule {
}
